<div class="item-tnc-container-parent">
  <div class="item-tnc-container">
    <div class="item-tnc-header">
      <h2 translate="TNC"></h2>
      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="tnc-text" [innerHTML]="termsAndConditionsHtml$ | async"></div>
  </div>
</div>
